import { useRef, useMemo } from 'react';
import { getCabins } from '../utils/cabin';
import SeatMapCabin from './SeatMapCabin';
import { jsx as _jsx } from "react/jsx-runtime";
const generateKey = index => `cabin_${index}`;
const SeatMapCabinLayout = _ref => {
  let {
    currentSegment,
    selectedDeck = {
      label: 'mainDeck',
      value: 'mainDeck'
    },
    activeSegment,
    onChange,
    seatTravelers
  } = _ref;
  const deckRef = useRef(null);
  const cabins = useMemo(() => getCabins(currentSegment, selectedDeck), [currentSegment, selectedDeck]);
  return /*#__PURE__*/_jsx("div", {
    ref: deckRef,
    children: (cabins === null || cabins === void 0 ? void 0 : cabins.length) > 0 && cabins.map((cabin, index) => /*#__PURE__*/_jsx(SeatMapCabin, {
      activeSegment: activeSegment,
      carrier: currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.carrier,
      onChange: onChange,
      seatTravelers: seatTravelers,
      ...cabin
    }, generateKey(index)))
  });
};
export default SeatMapCabinLayout;
//# sourceMappingURL=SeatMapCabinLayout.js.map